/* oxlint-disable @fullscript/gql-file-usage */
import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { AccountType, AccountTypeFilterObject } from "@shared/types/graphqlGenerated";

const AccountTypes_Shared_Query = gql`
  query AccountTypes_Shared_Query($filter: AccountTypeFilterObject) {
    viewer {
      accountTypes(filterObject: $filter) {
        value
        presentation
      }
    }
  }
`;

interface AccountTypesData {
  viewer: {
    accountTypes: AccountType[];
  };
}
interface AccountTypesVariables {
  filter: AccountTypeFilterObject;
}

const useAccountTypesQuery = (
  options?: QueryHookOptions<AccountTypesData, AccountTypesVariables>
) => {
  return useQuery<AccountTypesData, AccountTypesVariables>(AccountTypes_Shared_Query, options);
};

export type { AccountTypesData };

/* oxlint-disable @fullscript/gql-no-manual-hook-declaration */
export { useAccountTypesQuery, AccountTypes_Shared_Query };
